import { render, staticRenderFns } from "./ref.vue?vue&type=template&id=2cb32aa2&"
import script from "./ref.vue?vue&type=script&lang=js&"
export * from "./ref.vue?vue&type=script&lang=js&"
import style0 from "./ref.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports